module.exports = __webpack_public_path__ + "static/media/8.dc8861f5.jpg";